import { render, staticRenderFns } from "./ProposalSummary.vue?vue&type=template&id=66122488&"
import script from "./ProposalSummary.vue?vue&type=script&lang=js&"
export * from "./ProposalSummary.vue?vue&type=script&lang=js&"
import style0 from "./ProposalSummary.vue?vue&type=style&index=0&id=66122488&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports